import React, { Component } from 'react';
import { Button, InputGroup, Input, InputGroupAddon, InputGroupText, FormText, FormGroup } from 'reactstrap';
import { Field, SubmissionError, reduxForm } from 'redux-form';
import agent from '../../agent';
import { store } from '../../store';
import validation from '../../shared/common/validation.js';

import {
    REGISTER_SUBMIT
} from '../../constants/actionTypes';

const validate = values => {
    const errors = {};
    if (values.password !== values.password2) {
        errors.password2 = "Passwords do not match";
    }
    return errors;
}

const mapStateToProps = state => ({
    ...state.register,
    appName: state.common.appName
});

const mapDispatchToProps = dispatch => ({
    onSubmit: (payload) =>
        dispatch({ type: REGISTER_SUBMIT, payload })
});

const renderField = ({
    input,
    label,
    type,
    icon,
    meta: { asyncValidating, touched, error, warning }
}) => (
        <FormGroup className="mb-3">
            <InputGroup>
                <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                        <i className={icon}></i>
                    </InputGroupText>
                </InputGroupAddon>
                    <Input {...input} type={type} placeholder={label}
                        className={touched ? (error ? 'is-invalid' : null) : null} />
            </InputGroup>
            {touched && (error && <FormText color="danger">{error}</FormText>)}
        </FormGroup>
    )

function submitData(values) {
    return agent.Authorization.register(values.firstname, values.lastname, values.username, values.email, values.password)
        .then(response => {
            store.dispatch({ type: REGISTER_SUBMIT, response })
        }).catch((error) => {
            if (error.response) {
                var errorList = {}
                for (var err in error.response.body.errors) {
                    errorList[err] = error.response.body.errors[err].message;
                }
                throw new SubmissionError(errorList);
            }
        });
}

const asyncValidate = (values, dispatch, props, blurredField) => {
    const previousErrors = props.asyncErrors;
    switch (blurredField) {
        case 'username':
            return agent.Authorization.checkusername(values.username)
                .then(response => {
                    if (response.status === 'username exists') {
                        throw Object.assign({}, previousErrors, {
                            [blurredField]: response.message
                        });
                    }
                })
        case 'email':
            return agent.Authorization.checkemail(values.email)
                .then(response => {
                    if (response.status === 'email exists') {
                        throw Object.assign({}, previousErrors, {
                            [blurredField]: response.message
                        });
                    }
                })
        default:
            break;
    }
    return new Promise(resolve => resolve());
}

class RegisterForm extends Component {
    render() {
        const { handleSubmit, submitting, pristine } = this.props
        const req = validation.basic;
        return (
            <form onSubmit={handleSubmit(submitData)}>
                <Field component={renderField} icon="icon icon-user" type="text" label="First Name" name="firstname" validate={[req.required]} />

                <Field component={renderField} icon="icon icon-user" type="text" label="Last Name" name="lastname" validate={[req.required]} />
                
                <Field component={renderField} icon="icon icon-user" type="text" label="Username" name="username" validate={[req.required]} />

                <Field component={renderField} icon="icon icon-envelope" type="text" label="Email" name="email" validate={[req.required, req.email]} />

                <Field component={renderField} icon="icon icon-lock" type="password" label="Password" name="password" validate={[req.required, req.minLength(6)]} />

                <Field component={renderField} icon="icon icon-lock" type="password" label="Repeat password" name="password2" validate={[req.required]} />

                <Button color="success" block type="submit" disabled={pristine || submitting}>Create Account</Button>
                <Button color="secondary" block href="/" disabled={submitting}>Cancel</Button>
            </form>
        );
    }
}

export default reduxForm({
    form: 'register',
    validate,
    asyncValidate,
    asyncBlurFields: ['username', 'email'],
    shouldAsyncValidate: ({ syncValidationPasses, trigger }) => {
        if (!syncValidationPasses) return false;
        return trigger !== 'submit';
    },
    mapStateToProps,
    mapDispatchToProps
})(RegisterForm);


// WEBPACK FOOTER //
// ./src/containers/forms/RegisterForm.js